<template>
  <div>
    <el-dialog title="选择奖品" :visible.sync="dialogVisibleFrom" width="1000px" center @close="dialogClose">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane v-if="isShowFirst" label="优惠券" name="first">
          <el-tabs v-model="listName" type="card" @tab-click="handleClickTwo">
            <!-- Note------通用优惠券 -->
            <el-tab-pane label="通用优惠券" name="two">
              <div class="topTis">
                <i class="el-icon-warning" style=" color: #EBAA3C;font-size: 14px"></i>
                <div class="desc">
                  <p>
                    仅支持通用优惠券的uuid
                    <el-button style="margin: 0 60px;color:#EBAA3C" type="text" @click="handleUrl()">去创建优惠券></el-button>
                  </p>
                </div>
              </div>
              <div>优惠券uuid: <el-input v-model="generalCoupon.batchKey" placeholder="请输入" style="width: 200px"></el-input> <span class="toLink" @click="toLink">uuid获取教程</span></div>
              <div class="generalCoupon">
                面额: <el-input v-model.number="generalCoupon.price"  @input="generalCoupon.price = getNumberData($event, 1)" placeholder="请输入" style="width: 200px"></el-input>
              </div>
              <div style="color:#2670fb;margin-top:50px">
                <el-button
                  type="primary"
                  style="width:150px"
                  @click="
                    setGeneralCoupon();
                    dialogVisibleFrom = false;
                  "
                >
                  确定
                </el-button>
              </div>
            </el-tab-pane>
            <el-tab-pane label="小程序优惠券" name="first">
              <div class="topTis">
                <i class="el-icon-warning" style=" color: #EBAA3C;font-size: 14px"></i>
                <div class="desc">
                  <p>
                    支持“官方渠道推广-商家抽奖平台.“官方渠道推广-购物小程序专享券"优惠券。
                    <el-button style="margin: 0 60px;color:#EBAA3C" type="text" @click="handleUrl()">去创建优惠券></el-button>
                    <span style="cursor: pointer;" @click="handleUrl1()">优惠券创建教程></span>
                  </p>
                </div>
              </div>
              <el-form :model="formListPrize" label-width="120px" style="margin-top:20px">
                <el-row :gutter="20" style="margin-left: -40px;">
                  <el-col :span="8">
                    <el-form-item label="优惠券名称:">
                      <el-input v-model="formListPrize.benefitName" placeholder="请输入" style="width: 200px"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="优惠券面额:">
                      <el-input v-model="formListPrize.startAmount" placeholder="请输入" style="width: 80px"></el-input> -
                      <el-input v-model="formListPrize.endAmount" placeholder="请输入" style="width: 80px"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <!-- 查询、重置按钮位置-->
                    <el-button size="small" class="search" @click="handleSearch('2')">
                      <i class="el-icon-search" style="display: inline-block; width: 14px; height: 12px"></i>
                      查询
                    </el-button>
                    <el-button size="small" class="reset" @click="handleReset('2')">重置</el-button>
                  </el-col>
                </el-row>
              </el-form>
              <el-table
                v-loading="tableLoading"
                :data="prizeTable"
                style="width: 100%"
                :header-cell-style="{ background: '#F8F9FF', 'text-align': 'left' }"
                :cell-style="{ 'text-align': 'left' }"
              >
                <el-table-column prop="benefitName" label="名称" width="200"> </el-table-column>
                <el-table-column prop="amount" label="面额" width="120"> </el-table-column>
                <el-table-column prop="conditions" label="门槛" width="120">
                  <template slot-scope="scope"> 满{{ scope.row.conditions }}元使用 </template>
                </el-table-column>
                <el-table-column label="使用时间" width="240">
                  <template slot-scope="scope">
                    起：{{ scope.row.startDate }}<br />
                    止：{{ scope.row.endDate }}
                  </template>
                </el-table-column>
                <el-table-column label="可发放数" prop="remainPrizeQuantity" width="120"></el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button
                      style="width: 50px;margin-left: -10px;color: #2670fb;"
                      type="text"
                      class="Notetake"
                      @click="
                        chooseTab(scope.row);
                        dialogVisibleFrom = false;
                      "
                    >
                      选择
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                style="text-align: right; margin-top: 20px"
                @size-change="handleSizeChangePrize"
                background
                @current-change="handleCurrentChangePrize"
                :page-sizes="[10, 20, 30, 50, 100, 500]"
                :page-size="formListPrize.size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="formListPrize.totalNum"
                :current-page="formListPrize.current"
              ></el-pagination>
            </el-tab-pane>
          </el-tabs>
        </el-tab-pane>
        <el-tab-pane v-if="isShowTwo" label="店铺积分" name="four">
          <div class="topTis">
            <i class="el-icon-warning" style=" color: #EBAA3C;font-size: 14px"></i>
            <div class="desc">
              <p>店铺积分：发放积分需要加入淘宝会员体系，并开通积分功能</p>
            </div>
          </div>
          <el-form ref="integralForm" :model="integralForm" label-width="72px">
            <el-form-item label="积分数量:">
              <el-input v-model.number="integralForm.discount" @input.native="checkputn" style="width: 320px"></el-input>
            </el-form-item>
            <el-button
              type="primary"
              style="width: 180px;margin-bottom:100px"
              @click="
                storePoint();
                dialogVisibleFrom = false;
              "
              >选择店铺积分奖品</el-button
            >
          </el-form>
        </el-tab-pane>
        <el-tab-pane v-if="isShowThree" :disabled="actual" label="实物" name="third">
          <div class="topTis">
            <i class="el-icon-warning" style=" color: #EBAA3C;font-size: 14px"></i>
            <div class="desc">
              <p>实物奖品需要用户中奖后在线填写邮寄地址方</p>
            </div>
          </div>
          <el-form ref="objectForm" :model="objectForm" label-width="72px">
            <el-form-item label="奖品来源:">
              <el-radio-group v-model="objectForm.resource" @change="cleanImg">
                <el-radio label="2">直接填写</el-radio>
                <el-radio label="1">从店铺中选择</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="objectForm.resource == 2">
              <div class="uploadBox">
                <el-upload
                  ref="upload"
                  action="#"
                  style="width:80px"
                  list-type="picture-card"
                  :on-change="handleChange"
                  :on-remove="handleRemove"
                  :http-request="httpRequest"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <div class="uploadBox-desc">
                  <p>建议上传尺寸：200px*200px</p>
                  <p>图片大小：300K以内</p>
                  <p>格式：jpg、png</p>
                </div>
              </div>
            </el-form-item>
            <el-form-item v-if="objectForm.resource == 1">
              <div v-if="objectForm.logo && objectForm.resource == 1">
                <img :src="objectForm.logo" alt="" style="width: 150px; height: 150px" />
              </div>
              <el-button class="shopClass" @click="handledialog()">选择店铺商品</el-button>
            </el-form-item>
            <el-form-item label="奖品名称:">
              <el-input v-model="objectForm.name" maxlength="12" show-word-limit style="width: 320px"></el-input>
            </el-form-item>
            <el-form-item label="奖品价值:">
              <el-input v-model="objectForm.discount" @input="objectForm.discount = getNumberData($event, 1, 0)" style="width: 80px"></el-input>
              <span> 元/件</span>
            </el-form-item>
            <el-button type="primary" style="width: 180px" @click="changeJP()" :disabled="!objectForm.name || !objectForm.discount">选择实物奖品</el-button>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <!-- 选择商品弹窗 -->
    <el-dialog title="选择商品" :visible.sync="dialogFormVisible" width="820px">
      <!-- <input-form style="margin: 20px 0" :inputData="commodityList" @toParentVal="searchContent"></input-form> -->
      <div class="screen-box">
        <div class="line">
          <div class="item" style="margin-right: 72px;">
            <span class="item-name">指定品牌：</span>
            <!-- 指定品牌弹出框 -->
            <el-popover width="280" v-model="brandVisible">
              <div class="brand-checked-wrapper">
                <div class="wrapper-header">
                  <span style="float: left">指定品牌</span>
                  <div style="clear: both"></div>
                </div>
                <div style="margin: 15px 0"></div>
                <el-checkbox-group v-model="checkedBrands" @change="handleCheckedBrandsChange">
                  <div v-infinite-scroll="load" style="overflow:auto;height:200px;" infinite-scroll-disabled="disabled1">
                    <el-checkbox :label="item" :key="index" v-for="(item, index) in brandOptions" style="display: block; margin-bottom: 8px;">{{
                      item.pidName
                    }}</el-checkbox>
                  </div>
                </el-checkbox-group>
              </div>
              <div style="justify-content: center;display:flex;align-items:center;">
                <span style="margin-right:5px">共{{ specifyformcrowdTotal }}条</span>
                <el-button size="mini" @click="brandVisible = false">取消</el-button>
                <el-button type="primary" size="mini" @click="brandConfirm()">确定</el-button>
              </div>
              <el-button slot="reference" plain size="small" class="brandButton">{{
                checkedBrands.length > 0 ? "已选择" + checkedBrands.length + "个" : "默认全部"
              }}</el-button>
            </el-popover>
          </div>
          <div class="item">
            <el-select v-model="classifyValue" placeholder="淘宝类目" class="classify-select" size="small" @change="classifyChange">
              <el-option v-for="item in classifyOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <el-popover placement="bottom" width="300" v-model="visible" popper-class="poper">
              <div class="popper-wrapper">
                <el-tree
                  ref="taobaoTree"
                  node-key="id"
                  v-if="classifyIndex === 1"
                  :data="taobaoCats"
                  :props="props"
                  show-checkbox
                  @check-change="handleCheckChange"
                ></el-tree>
                <el-tree
                  ref="sellerTree"
                  node-key="id"
                  v-else-if="classifyIndex === 2"
                  :data="sellerCats"
                  :props="props"
                  show-checkbox
                  @check-change="handleCheckChange"
                ></el-tree>
              </div>
              <div style="text-align: right; margin-top: 20px">
                <el-checkbox v-model="checkedAll" @change="handleCheckAllChangeTaoBao" style="float: left; line-height: 26px">全选</el-checkbox>
                <el-button size="mini" type="text" @click="visible = false">取消</el-button>
                <el-button type="primary" size="mini" @click="getCheckedKeys()">确定</el-button>
              </div>
              <el-button slot="reference" size="small" class="goods-button">
                {{ classifyIdArray.length > 0 ? "已选择" + classifyIdArray.length + "项" : "默认全部" }}
              </el-button>
            </el-popover>
          </div>
        </div>
        <div class="line">
          <div class="item" style="margin-right: 15px">
            <span class="item-name">商品名称：</span>
            <el-input class="short-input" style="width: 300px" placeholder="请输入商品名称" size="small" v-model="itemTitle"></el-input>
          </div>
          <div class="item" style="margin-right: 15px">
            <span class="item-name">商品ID：</span>
            <el-input
              class="short-input"
              style="width: 300px"
              placeholder="请输入商品ID,多个商品ID间用逗号分隔"
              size="small"
              @input="validNum"
              v-model="numIid"
            ></el-input>
          </div>
        </div>
        <div class="line">
          <el-button class="button" size="small" type="primary" @click="searchList()">查询</el-button>
        </div>
      </div>
      <el-table
        :data="tableShopData"
        stripe
        style="width: 90%; margin: 0 auto"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
      >
        <el-table-column width="100">
          <template slot-scope="scope">
            <img :src="scope.row.logo" class="avar" alt="商品图片" style="height: 60px; width: 60px" />
          </template>
        </el-table-column>
        <el-table-column prop="skuName" label="商品名称" width="300">
          <template slot-scope="scope">
            <a :href="scope.row.itemUrl" target="_blank"
              >{{ scope.row.skuName }}<br />
              ¥{{ scope.row.jdPrice }}</a
            >
          </template>
        </el-table-column>
        <el-table-column prop="skuId" label="SKU ID" width="200"> </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="chooseShop(scope.row)" style="width: 50px">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin: 40px 80px 0 0; text-align: right"
        background
        @size-change="handleSizeChangeThr"
        @current-change="handleCurrentChangeThr"
        :current-page="formShopList.current"
        :page-sizes="[5, 10, 30, 50, 100]"
        :page-size="formShopList.size"
        layout="total, sizes, prev, pager, next, jumper"
        class="pagination"
        :total="totalListThr"
      ></el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import inputForm from "../../components/inputForm";
import SelectGoods from "../../components/selectGoodsMonitor";
import { mapState } from "vuex";
import { couponList, jingdouList, allAccountList, redPacketList } from "@/api/integralCenter/prizeCenter.js";
import { querySellerCouponWriteList, querySellerCouponExternalList } from "@/api/integralCenter/couponWriteController";
// import { getTaobaoItemList } from "@/api/public1";
import { uploadpic } from "@/api/paradiseAndTaskCommonController.js";
import { getPrize, getSpecialGoods } from "@/api/thd.js";
import {
  getBrandList,
  getTaobaocats,
  getSellercats,
  getTaobaoItemList,
  getTaobaoItemSkuList,
  addUnshelveItem,
  taobaoItemGroupList,
  getTaobaoItemFromGroup,
  deleteTaobaoItemGroup,
  addTaobaoItemGroup,
} from "@/api/public1";
const actionType = ["", "jingdouPut"];
export default {
  name: "selectProduct",
  components: {
    inputForm,
    SelectGoods,
  },
  props: {
    hide: null,
    isShow: {
      type: Boolean,
      default: false,
    },
    tipShow: {
      type: Boolean,
      default: false,
    },
    putPrize: {
      type: Object,
    },
    //typeDefault可不传 默认京券 免费领取 不公开 （店铺礼包、每日抢、评价有礼、裂变神券、天降红包雨大转盘抽奖 ，互动中心-会员权益-新人优惠券、会员券）
    typeDefault: {
      type: Object,
      default() {
        return {
          grantType: 3, // 发放类型  传对应的id值
          display: 1, // 是否公开  传对应的id值
          type: 0, // 不禁用  传对应的id值
          noDisabled: [3], // 不禁用  传对应的id值  可不传（全部可选）
        };
      },
    },
    // num != 2 JingdouCount中的prizeCount必传 计算填的京豆总数是否大于京豆总数
    JingdouCount: {
      type: Object,
      default() {
        return {
          prizeCount: 0,
        };
      },
    },
    num: {
      default: 2,
    },
  },
  computed: {
    ...mapState(["venderType"]),
  },
  data() {
    return {
      belongRadio: "",
      isShowTwo: true,
      checkedBrandsString: "",
      classifyIdString: "",
      numIid: "",
      itemTitle: "",
      classifyIdArray: [],
      checkedAll: false,
      props: {
        label: "speName001",
        children: "child",
      },
      cats: [], //当前展示的类目
      taobaoCats: [], //淘宝类目
      sellerCats: [], //店铺类目
      classifyIndex: 1,
      visible: false, //类目渲染
      classifyOptions: [
        {
          value: 1,
          label: "淘宝类目",
        },
        {
          value: 2,
          label: "店铺类目",
        },
      ],
      classifyValue: 1,
      specifyformcrowdTotal: 100,
      brandOptions: [], //品牌列表
      checkedBrands: [], //选中品牌
      brandVisible: false, //指定品牌弹出框
      // 商品搜索
      AlipayForm: {
        region: "",
        quantityBalance: 0,
        num: "",
      },
      AlipaySelectList: [],
      prizeTable: [],
      formListPrize: {
        size: 10,
        current: 1,
        startAmount: "",
        endAmount: "",
        rightTypeId: 3,
        benefitName: "",
        totalNum: 0,
      },
      generalCoupon: {
        batchKey: "",
        price: "",
        assetsId: null,
        couponType: 4,
        prizeType: 1,
        singleAmount: 1,
      },
      isShowFirst: true, //邀请开卡活动隐藏优惠券一栏
      actual: false,
      fileList: [],
      form: {
        imageUrl: "",
      },
      dialogFormVisible: false,
      // returnSelectGoods: [],
      returnSelectGoodsAppoint: [], //选择商品回显
      postForm: {
        orderStartTime: "",
        testSelect: 0,
      },
      goodsStateLength: 0,
      goodsStateLength1: 0,
      selectList: [],
      eKselectList: [],
      redSelectList: [],
      tableLoading: true,
      activeName: "first",
      listName: "two",
      // 互动任务-店铺礼包、每日抢、评价有礼、裂变神券、天降红包雨】、【互动乐园-大转盘抽奖 默认京券 免费领取 不公开
      inputData: [
        {
          name: "类型:",
          val: "type",
          placeholder: "请选择",
          selectArr: [
            { label: "京券", id: 0, defaultValue: 0 },
            { label: "东券", id: 1 },
          ],
        },
        {
          name: "发放类型:",
          val: "grantType",
          placeholder: "请选择",
          selectArr: [
            { label: "促销绑定", id: 1, defaultValue: 3, disabled: true },
            { label: "推送", id: 2, disabled: true },
            { label: "免费领取", id: 3, disabled: false },
            { label: "京豆换券", id: 4, disabled: true },
            { label: "互动平台", id: 5, disabled: true },
          ],
        },
        {
          name: "是否公开:",
          val: "display",
          placeholder: "请输入",
          selectArr: [
            { label: "不公开", id: 1, defaultValue: 1 },
            { label: "公开", id: 3 },
          ],
        },
      ],
      inputDataTwo: [
        {
          name: "优惠券名称:",
          val: "name",
          placeholder: "请输入",
        },
        {
          name: "优惠券面额:",
          val: "discount",
          placeholder: "请输入",
        },
      ],
      internalTable: [],
      externalTable: [],
      totalNum: 0,
      totalNumTwo: 0,
      jingduoForm: {
        count: null,
      },
      objectForm: {
        logo: "",
        resource: "1",
        name: "",
        discount: null,
      },
      integralForm: {
        discount: null,
      },
      ekForm: {},
      aqyForm: {},
      plusForm: {},
      redForm: {},
      dialogImageUrl: "",
      dialogVisible: false,
      dialogVisibleFrom: this.isShow,
      formList: {
        current: 1,
        size: 10,
        isTake: 1,
      },
      formListTwo: {
        current: 1,
        size: 10,
        isTake: 1,
      },
      formLitJD: {
        current: 1,
        size: 100,
        isFilterUsed: true,
        status: 2,
      },
      formLitZC: {
        current: 1,
        size: 100,
        isFilterUsed: true,
        status: 2,
      },
      formLitRed: {
        current: 1,
        size: 100,
        isFilterUsed: true,
        status: 2,
      },
      jingdouData: {},
      tabActive: 3,
      selectZCList: {},
      zcData: {},
      commodityList: [
        {
          name: "商品类目:",
          placeholder: "请选择",
          val: "categoryId",
          cascaderArr: [],
          multiple: true,
          width: 240,
        },
        {
          name: "SKU ID:",
          val: "skuId",
          placeholder: "请输入SKU ID",
          isNumber: true,
          width: 240,
        },
        {
          name: "商品名称:",
          val: "skuName",
          placeholder: "请输入商品名称",
          width: 240,
        },
        {
          name: "商品状态:",
          val: "skuStatus",
          default: 1,
          selectArr: [
            { label: "全部", id: null },
            { label: "上架", id: 1 },
            { label: "下架", id: 2 },
          ],
          width: 136,
        },
      ],
      tableShopData: [],
      tableBelongData: [],
      belongPage: {
        current: 1,
        size: 10,
        total: 0
      },
      totalListThr: 0,
      formShopList: { current: 1, size: 5, skuStatus: 1 },
      nowTime: "",
      activeSendtimes: "",
      planList: {
        jingdou: {},
      },

      isShowThree: false, //调查问卷显示实物一行
    };
  },
  mounted() {
    // 类型默认
    this.inputData[0].selectArr[0].defaultValue = this.typeDefault.type;
    // 是否公开
    this.inputData[2].selectArr[0].defaultValue = this.typeDefault.display;
    // 发放类型 禁用
    this.inputData[1].selectArr[0].defaultValue = this.typeDefault.grantType;
    if (this.typeDefault && this.typeDefault.noDisabled) {
      this.inputData[1].selectArr.forEach((item) => {
        this.typeDefault.noDisabled.forEach((i) => {
          if (item.id === i) {
            item.disabled = false;
          } else {
            item.disabled = true;
          }
        });
      });
    }
    this.formList.type = this.typeDefault.type;
    this.formList.display = this.typeDefault.display;
    this.formList.grantType = this.typeDefault.grantType;
    this.prizeList(); //优惠券
    // this.quireList();
    this.getShopList(); // 实物
    this.AlipayList(); //红包
    // 邀请开卡v3.4
    if (this.$parent.localStepNum == 4) {
      // this.setDefalut();
      console.log(this.$parent.clickActual);
      var tj1 = this.$parent.tableData.some((i) => {
        return i.prizeType == 3;
      });
      // 点击到已选实物奖品的条件，不置灰实物tab
      var tj2 = this.$parent.clickActual;
      this.actual = tj1 && tj2 ? true : false;
      this.isShowFirst = false;
      this.activeName = "third";
    }
    if (this.$parent.localStepNum == 27 || this.$parent.localStepNum == 26) {
      // this.setDefalut();
      console.log(this.$parent.clickActual);
      var tj1 = this.$parent.tableData.some((i) => {
        return i.prizeType == 3;
      });
      // 点击到已选实物奖品的条件，不置灰实物tab
      var tj2 = this.$parent.clickActual;
      this.actual = tj1 && tj2 ? true : false;
      this.isShowFirst = false;
      this.isShowTwo = false;
      this.activeName = "third";
    }

    // 调查问卷显示实物tab
    if(this.$parent.activityData.id==31) {
      this.isShowThree = true;
    }
  },
  methods: {
    toLink() {
      window.open("https://www.yuque.com/yunduanxincrm/sd6oeu/sxapyqr9zpobldh9?singleDoc#", "_blank");
    },  

    // 选择专属商品
    selectBelong() {
      const selectBelongGoods = this.tableBelongData.filter((item) => {
        return item.id == this.belongRadio
      })
      if(selectBelongGoods.length == 0) {
        this.$message.warning("请选择商品")
        return
      }
      this.dialogVisibleFrom = false;
      this.$emit("choose-shop", selectBelongGoods[0], 10);
    },

    // 添加专属商品
    addBelongGoods() {
      window.open("https://fuwu.taobao.com/ser/miniAppUse.htm?articleCode=FW_GOODS-1001212154#/", "_blank");
    },

    // 选择通用优惠券
    setGeneralCoupon() {
      this.$emit("choose-shop", this.generalCoupon, 1);
    },

    handleUrl() {
      window.open("https://fuwu.taobao.com/ser/miniAppUse.htm?articleCode=FW_GOODS-1001212154#/", "_blank");
    },
    handleUrl1() {
      window.open("https://www.yuque.com/yunduanxincrm/sd6oeu/sxapyqr9zpobldh9", "_blank");
    },
    handledialog() {
      this.checkedBrandsString = "";
      this.checkedBrands = [];
      this.checkedAll = false;
      this.numIid = "";
      this.itemTitle = "";
      this.classifyValue = 1;
      this.classifyIdArray = [];
      this.classifyIdString = "";
      this.dialogFormVisible = true;
    },
    /*
     * 查询按钮
     * */
    searchList() {
      // 执行查询接口
      this.formShopList.current = 1,
      this.formShopList.size = 5,
      this.getShopList();
    },
    //
    validNum(val) {
      this.numIid = val.replace(/[^0-9\,]/g, "");
    },

    getCheckedKeys() {
      const that = this;
      let classifyIndex = that.classifyIndex;
      let classifyIdArray = [];
      if (classifyIndex == 1) {
        // console.log(that.$refs.taobaoTree.getCheckedKeys());
        classifyIdArray = that.$refs.taobaoTree.getCheckedKeys();
        that.classifyIdArray = classifyIdArray;
        that.classifyIdString = classifyIdArray.join(",");
      } else if (classifyIndex == 2) {
        // 获取所有选中的id
        // console.log(that.$refs.sellerTree.getCheckedKeys());
        classifyIdArray = that.$refs.sellerTree.getCheckedKeys();
        that.classifyIdArray = classifyIdArray;
        that.classifyIdString = classifyIdArray.join(",");
      }
      that.visible = false;
    },
    /*
     * 商品类目全选按钮监听事件
     * */
    handleCheckAllChangeTaoBao(val) {
      if (val) {
        if (this.classifyIndex === 1) {
          this.$refs.taobaoTree.setCheckedNodes(this.taobaoCats);
        } else {
          this.$refs.sellerTree.setCheckedNodes(this.sellerCats);
        }
      } else {
        if (this.classifyIndex === 1) {
          this.$refs.taobaoTree.setCheckedNodes([]);
        } else {
          this.$refs.sellerTree.setCheckedNodes([]);
        }
      }
    },
    /*
     * 树形控件相关
     * */
    handleCheckChange(data, checked, indeterminate) {
      // console.log(data, checked, indeterminate);
      // 判断全选状态，根据索引来
      if (this.classifyIndex === 1) {
        // console.log('淘宝');
        let arr = this.$refs.taobaoTree.getCheckedKeys();
        // console.log(arr)
        // console.log(this.taobaoCats)
      } else {
        // console.log('店铺');
        let arr = this.$refs.sellerTree.getCheckedKeys();
        // console.log(arr)
        // console.log(this.sellerCats)
      }
    },
    /*
     * 监听类目的变化
     * */
    classifyChange(value) {
      this.classifyIndex = value;
      this.checkedAll = false;
      this.classifyIdArray = [];
      this.classifyIdString = "";
    },
    /* 品牌弹窗确认按钮 */
    brandConfirm() {
      const that = this;
      let checkedBrands = that.checkedBrands;
      let checkedBrandsArray = [];
      checkedBrands.forEach(function(value) {
        checkedBrandsArray.push(value.pid);
      });
      // console.log("%c 选中的品牌Id", "color: green", checkedBrandsArray);
      that.checkedBrandsString = checkedBrandsArray.join(",");
      that.brandVisible = false;
    },
    //
    handleCheckedBrandsChange(value) {
      // console.log("%c 品牌单选事件", "color: green", value);
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.brandOptions.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.brandOptions.length;
    },
    // 商品搜索
    load() {
      // let index = this.loadIndex;
      // let data =  this.specifyData[index];
      // this.brandOptions.push(data);
      // this.loadIndex++;
      let data = [];
      console.log('specifyform',this.specifyform);
      getBrandList(this.specifyform)
        .then((res) => {
          // console.log("%c 品牌列表", "color: green", res.data);
          if (res.code === 200) {
            console.log(res);
            data = res.data.dataList;
            data.forEach((item) => {
              this.specifyData.push(item);
            });
            this.brandOptions = this.specifyData;
          }
        })
        .then(() => {
          this.specifyform.pageNum++;
        });
    },
    //
    // 支付宝红包
    AlipayInfo() {
      console.log(this.AlipayForm.region, 9999);
      this.generalCoupon = {
        batchKey: "",
        price: "",
        assetsId: null,
        couponType: 4,
        prizeType: 1,
        singleAmount: 1,
      };
      let params = {
        couponId: this.AlipayForm.region.id,
        discount: this.AlipayForm.num,
        name: this.AlipayForm.region.benefitName,
        singleAmount: 1,
      };
      this.$emit("choose-shop", params, 8);
    },
    changeAlipay(val) {
      console.log('选择红包计划',val)
      this.AlipayForm.num = val.amount;
      this.AlipayForm.quantityBalance = val.remainPrizeQuantity;
    },
    // 优惠券
    async AlipayList() {
      const { data: res } = await getPrize({ rightTypeId: 1, size: 999, current: 1 });
      this.AlipaySelectList = res.records;
    },
    async prizeList() {
      this.tableLoading = true;
      const { data: res } = await getPrize(this.formListPrize);
      this.prizeTable = res.records;
      this.formListPrize.totalNum = res.total * 1;
      this.tableLoading = false;
    },
    //  内部搜索
    handleSearch(val) {
      this.prizeList();
    },
    // 重置
    handleReset(val) {
      this.formListPrize.benefitName = "";
      this.formListPrize.startAmount = "";
      this.formListPrize.endAmount = "";
      this.prizeList();
    },
    //分页事件
    handleSizeChangePrize(val) {
      this.formListPrize.size = val;
      this.prizeList();
    },
    handleCurrentChangePrize(val) {
      this.formListPrize.current = val;
      this.prizeList();
    },
    planChange(val) {
      console.log(val);
      this.activeSendtimes = val.sendTimes;
    },
    setDefalut() {
      if (this.putPrize.prizeType) {
        console.log(this.putPrize);
      }
    },
    dialogClose() {
      this.$emit("close");
    },

    cleanImg() {
      this.objectForm.logo = "";
      this.objectForm.name = "";
      this.objectForm.discount = null;
    },
    dateFormat() {
      let date = new Date();
      let year = date.getFullYear();

      let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
      let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      let hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      // 拼接
      this.nowTime = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
      // console.log(this.nowTime);
    },
    jumpCreation() {
      window.open("https://passport.shop.jd.com/login/index.action?ReturnUrl=https%3A%2F%2Fpromo.shop.jd.com%2Fweb%2Fcoupon%2Fdetail%2Fshop%2F0%3F");
      // let routeUrl = this.$router.resolve({
      //   path: "/integralCenter/prizeCenter/coupon_management",
      // });
      // window.open(routeUrl.href, "_blank");
    },
    jumpSansCreation() {
      this.$router.push({
        path: "./prizeCenter/coupon_management",
        query: { to: 1 },
      });
    },
    jumpJingduo() {
      let routeUrl = this.$router.resolve({
        path: "/integralCenter/prizeCenter/asset_management",
      });
      window.open(routeUrl.href, "_blank");
    },
    jumpEkCz() {
      window.open("http://quanyi.shop.jd.com/#/eAccount");
    },
    jumpEk() {
      let routeUrl = this.$router.resolve({
        path: "/integralCenter/prizeCenter/asset_management",
        query: { tabAct: 3 },
      });
      window.open(routeUrl.href, "_blank");
    },
    jumpaqyCz() {
      window.open("https://quanyi.shop.jd.com/#/aiqiyiAccount");
    },
    jumpaqy() {
      let routeUrl = this.$router.resolve({
        path: "/integralCenter/prizeCenter/asset_management",
        query: { tabAct: 4 },
      });
      window.open(routeUrl.href, "_blank");
    },
    jumpPlusCz() {
      window.open("https://quanyi.shop.jd.com/#/plusAccount");
    },
    jumpPlus() {
      let routeUrl = this.$router.resolve({
        path: "/integralCenter/prizeCenter/asset_management",
        query: { tabAct: 5 },
      });
      window.open(routeUrl.href, "_blank");
    },
    jumpRedCz() {
      window.open("https://quanyi.shop.jd.com/#/redGiftAccount");
    },
    jumpRed() {
      let routeUrl = this.$router.resolve({
        path: "/integralCenter/prizeCenter/asset_management",
        query: { tabAct: 6 },
      });
      window.open(routeUrl.href, "_blank");
    },
    //获取店铺商品
    getShopList() {
      // this.formShopList;
      // let params = {
      //   approveStatus: "",
      //   categoryType: 1,
      //   cid: "",
      //   endPrice: "",
      //   itemTitle: "",
      //   numIid: "",
      //   pageNum: 1,
      //   pageSize: 10,
      //   pid: "",
      //   startPrice: "",
      // };
      const self = this;
      let checkedBrandsString = self.checkedBrandsString, //指定品牌ID数组
        classifyIndex = self.classifyIndex, //商品类目类型
        classifyIdString = self.classifyIdString, //宝贝类目id数组
        itemTitle = self.itemTitle, //商品名称(请输入商品名称、商品编码、商品id、关键词)
        goodValue = "", //商品状态
        startPrice = "", //开始价格
        endPrice = ""; //结束价格
      // 判断商品类目 0店铺类目 1淘宝类目
      if (classifyIndex === 2) {
        // 店铺
        classifyIndex = 0;
      }
      // 判断商品状态 不填''查全部，在售 1，待售 2
      if (self.goodValue === 0) {
        goodValue = "";
      }
      var formData = {
        approveStatus: goodValue,
        categoryType: classifyIndex,
        cid: classifyIdString,
        endPrice: endPrice,
        itemTitle: itemTitle, //商品名称
        numIid: self.numIid, //商品id
        pageNum: self.formShopList.current,
        pageSize: self.formShopList.size,
        pid: checkedBrandsString,
        startPrice: startPrice,
      };

      getTaobaoItemList(formData).then((res) => {
        console.log(res, 99999);
        this.tableShopData = res.data.dataList.map((item) => {
          return {
            ...item,
            logo: item.picUrl,
            discount: item.price,
            wareId: item.numIid,
            skuId: item.numIid,
            skuName: item.itemTitle,
            jdPrice: item.price,
          };
        });
        this.totalListThr = Number(res.data.pageInfo.total);
      });
    },

    transverter(data) {
      // 排重
      let obj = {};
      for (let i = 0; i < data.length; i++) {
        obj[data[i]["categoryId"]] = data[i];
      }
      let arr = Object.values(obj);
      var newData = [];
      // console.log(arr);
      for (var i = 0; i < arr.length; i++) {
        newData[i] = {
          value: arr[i].categoryId,
          parent_id: arr[i].parentId,
          label: arr[i].name,
          isChecked: false,
        };
      }
      return newData;
    },
    getTrees(list, parent_id = 0) {
      let parentObj = {};
      list.forEach((o) => {
        parentObj[o.id] = o;
      });
      if (!parent_id) {
        return list
          .filter((o) => !parentObj[o.parent_id])
          .map((o) => {
            if (this.getTrees(list, o.value).length == 0) {
              // console.log(this.getTrees(list, o.value).length);
              delete o.children;
              return o;
            } else {
              return (o.children = this.getTrees(list, o.value)), o;
            }
          });
      } else {
        return list
          .filter((o) => o.parent_id == parent_id)
          .map((o) => {
            if (this.getTrees(list, o.value).length == 0) {
              // console.log(this.getTrees(list, o.value).length);
              delete o.children;
              return o;
            } else {
              return (o.children = this.getTrees(list, o.value)), o;
            }
          });
      }
    },
    //实物选择
    chooseShop(val) {
      console.log(val);
      this.objectForm.logo = val.logo;
      this.objectForm.name = val.skuName.substr(0, 12);
      this.objectForm.discount = val.jdPrice;
      this.objectForm.wareId = this.venderType ? val.skuId : val.wareId;
      this.dialogFormVisible = false;
    },
    searchContent(val) {
      this.formShopList.size = 5;
      this.formShopList.current = 1;
      if (val.categoryId) {
        this.formShopList.categoryId = val.categoryId.join(",");
      } else {
        this.formShopList.categoryId = "";
      }
      this.formShopList.skuId = val.skuId;
      this.formShopList.skuStatus = val.skuStatus;
      this.formShopList.skuName = val.skuName;
      this.getShopList();
    },
    //获取优惠券
    quireList() {
      this.dateFormat();
      // this.formList.beginTime = this.nowTime;
      couponList(this.formList).then((res) => {
        this.tableLoading = false;
        this.internalTable = res.data.records;
        this.internalTable.forEach((item) => {
          item.couponType = 1;
        });
        this.totalNum = Number(res.data.total);
      });
    },
    //查询外部优惠券信息
    querySellerCouponExternal() {
      this.tableLoading = true;
      querySellerCouponExternalList(this.formListTwo)
        .then((res) => {
          this.externalTable = res.data.records;
          this.externalTable.forEach((item) => {
            item.couponType = 2;
            item.couponId = Number(item.id);
          });
          this.totalNumTwo = Number(res.data.total);
          this.tableLoading = false;
          console.log(this.externalTable, 22244);
        })
        .catch((res) => {});
    },
    //输入框限制负数
    checkputn(e) {
      let filtered = e.target.value.replace(/^0|[^\d]/g, "");
      e.target.value = Number(filtered);
      // //下边写用户输入时需要的执行逻辑
      // if(this.ruleForm.inputprize!= filtered) {
      //     this.ruleForm.inputprize = filtered
      // }
      // 不能输入0，绑定的值如果小于1，那么输入框置空
      if (e.target.value < 1) {
        e.target.value = "";
      }
    },
    change(a) {
      console.log(a);
      this.ekForm.quantityBalance = a.value.quantityBalance;
      this.aqyForm.quantityBalance = a.value.quantityBalance;
      this.plusForm.quantityBalance = a.value.quantityBalance;
      this.redForm.quantityBalance = a.value.quantityTotal ? a.value.quantityTotal - a.value.quantityActual : "";
      this.ekForm.num = 1;
      this.aqyForm.num = 1;
      this.plusForm.num = 1;
      this.redForm.num = a.value.quantityAmount ? a.value.quantityAmount / a.value.quantityTotal : "";
    },
    //选择奖品弹窗
    openDialog() {
      this.dialogVisibleFrom = true;
      // this.getJingdouList();
    },
    //查询京豆
    getJingdouList() {
      jingdouList(this.formLitJD)
        .then((res) => {
          let selectArr = res.data.records.map((item) => {
            return {
              label: item.planName,
              value: item.id,
              sendTimes: item.sendTimes,
            };
          });
          this.selectList = selectArr;
          this.planList.jingdou = res.data.records;
        })
        .catch((res) => {});
    },
    //京豆
    getJingdouData() {
      console.log("this.jingduoForm", this.jingduoForm);
      this.jingdouData = {
        couponId: this.jingduoForm.region.value,
        // discount: this.jingduoForm.quota,
        discount: Number(this.jingduoForm.count),
        name: this.jingduoForm.region.label,
        singleAmount: Number(this.jingduoForm.count),
      };
    },
    setJingdouData() {
      let jingdouPlanList = this.planList.jingdou;
      let item = jingdouPlanList.find((i) => {
        return i.id == this.jingdouData.couponId;
      });
      // console.log("item, this.$parent.ruleForm.peopleCount", item, this.$parent.ruleForm, this.JingdouCount);
      if (this.num == 2) {
        if (item) {
          // 梯度奖励
          if (this.$parent.ruleForm.isCumulativePrize) {
            let line = this.$parent.tableData[this.$parent.tableIndex];
            console.log(line);
            if (!line.peopleCount || Number(line.peopleCount) > 20) {
              this.$message.warning("京豆奖励需先填写最多邀请人数规则，且数目不可大于20人");
              return;
            } else if (Number(line.peopleCount) > item.sendTimes) {
              this.$message.error("奖品发放规则与京豆计划的发豆规则不一致，会导致奖品发放失败，请重新选择京豆计划～");
              return;
            }
            if (
              this.jingdouData.singleAmount &&
              line.prizeCount &&
              Number(this.jingdouData.singleAmount) * Number(line.prizeCount) > Number(item.quantityTotal)
            ) {
              this.$message.error("京豆发放数量不能大于该京豆预算额！");
              return;
            }
            if (this.jingdouData.singleAmount && Number(this.jingdouData.singleAmount) > Number(item.quantityTotal)) {
              this.$message.error("单份奖励个数不能大于该京豆预算额！");
              return;
            }
            if (!this.jingdouData.singleAmount) {
              this.$message.error("请填写京豆单份奖励个数！");
              return;
            }
          } else {
            // console.log("this.$parent.ruleForm", this.$parent.ruleForm);
            if (!this.$parent.ruleForm.peopleCount || Number(this.$parent.ruleForm.peopleCount) > 20) {
              this.$message.warning("京豆奖励需先填写最多邀请人数规则，且数目不可大于20人");
              return;
            } else if (Number(this.$parent.ruleForm.peopleCount) > item.sendTimes) {
              this.$message.error("奖品发放规则与京豆计划的发豆规则不一致，会导致奖品发放失败，请重新选择京豆计划～");
              return;
            }
            if (
              Number(this.$parent.ruleForm.prizeCount) &&
              this.jingdouData.singleAmount &&
              Number(this.$parent.ruleForm.prizeCount) * Number(this.jingdouData.singleAmount) > Number(item.quantityTotal)
            ) {
              this.$message.error("京豆发放数量不能大于该京豆预算额！");
              return;
            }
            if (this.jingdouData.singleAmount && Number(this.jingdouData.singleAmount) > Number(item.quantityTotal)) {
              this.$message.error("单份奖励个数不能大于该京豆预算额！");
              return;
            }
            if (!this.jingdouData.singleAmount) {
              this.$message.error("请填写京豆单份奖励个数！");
              return;
            }
          }
        }
      } else {
        let line = this.JingdouCount;
        if (item) {
          if (
            line.prizeCount &&
            this.jingdouData.singleAmount &&
            Number(line.prizeCount) * Number(this.jingdouData.singleAmount) > Number(item.quantityTotal)
          ) {
            this.$message.error("京豆发放数量不能大于该京豆预算额！");
            return;
          }
          if (this.jingdouData.singleAmount && Number(this.jingdouData.singleAmount) > Number(item.quantityTotal)) {
            this.$message.error("单份奖励个数不能大于该京豆预算额！");
            return;
          }
          if (!this.jingdouData.singleAmount) {
            this.$message.error("请填写京豆单份奖励个数！");
            return;
          }
          // if (!line.prizeCount) {
          //   this.$message.error("京豆奖励需先填写奖品总份额！");
          //   return;
          // }
        }
      }

      // return
      this.dialogVisibleFrom = false;
      // this.jingdouData.couponId()
      this.$emit("choose-shop", { ...this.jingdouData, quantityTotal: item.quantityTotal }, 2);
    },
    //查询京东E卡,爱奇艺会员,京豆PLUS会员
    acquireAssets() {
      allAccountList(this.formLitZC)
        .then((res) => {
          let selectArr = res.data.records.map((item) => {
            return {
              label: item.planName,
              value: item,
            };
          });
          this.eKselectList = selectArr;
          // console.log(res, "res");
        })
        .catch((res) => {});
    },
    //查询红包
    redBag() {
      redPacketList(this.formLitRed)
        .then((res) => {
          let selectArr = res.data.records.map((item) => {
            return {
              label: item.planName,
              value: item,
            };
          });
          this.redSelectList = selectArr;
          // console.log(res, "res");
        })
        .catch((res) => {});
    },
    handleClick(tab, event) {
      if (tab.name == "first") {
        this.formLitZC.assetType = 1;
      }
      if (tab.name == "1") {
        this.formLitZC.assetType = 2;
        this.jingduoForm.count = ""; //京豆
      }
      if (tab.name == "third") {
        this.formLitZC.assetType = 3; //实物
        this.objectForm.resource = "1";
        this.objectForm.name = "";
        this.objectForm.discount = "";
        /* 获取品牌列表
         * */
         console.log('specifyform',this.specifyform);
        getBrandList({}).then((res) => {
          // console.log("%c 品牌列表", "color: green", res.data);
          // if(res.code === 200){
          console.log(res);
          this.specifyData = res.data.dataList;
          this.brandOptions = this.specifyData;
          this.specifyformcrowdTotal = parseInt(res.data.pageInfo.total);
          // };
          /*
           * 获取淘宝类目
           * */
          getTaobaocats({}).then((res) => {
            // console.log("%c 淘宝类目", "color: green", res.data);
            this.cats = res.data;
            this.taobaoCats = res.data;
          });
          /*
           * 获取店铺类目
           * */
          getSellercats({}).then((res) => {
            // console.log("%c 店铺类目", "color: green", res.data);
            this.sellerCats = res.data;
          });
        });
      }
      if (tab.name == "four") {
        this.formLitZC.assetType = 4; //店铺积分
        this.integralForm.discount = "";
      }
      // 专属下单奖品
      if(tab.name == "ten") {
        this.belongPage = {
          current: 1,
          size: 10,
          total: 0,
        } 
        this.belongRadio = ""
        this.getSpecialGoods()
      }
      if (tab.name == "4") {
        this.formLitZC.assetType = 5; //E卡
        this.ekForm.quantityBalance = "";
        this.ekForm.num = "";
      } else if (tab.name == "5") {
        this.formLitZC.assetType = 6; //爱奇艺会员
        this.aqyForm.quantityBalance = "";
        this.aqyorm.num = "";
      } else if (tab.name == "6") {
        this.formLitZC.assetType = 7; //PLUS会员
        this.plusForm.quantityBalance = "";
        this.plusForm.num = "";
      }
      if (tab.name == "eig") {
        this.formLitZC.assetType = 8; //现金红包
        this.redForm.num = "";
      }
      // this.acquireAssets(); // 爱奇艺
      // this.redBag(); // 红包
      // console.log(tab.index, this.tabActive);
    },
    handleClickTwo(tab, event) {
      // console.log(tab);
      // console.log(event);
      // console.log(tab.name);
      if (tab.name == "second") {
        this.querySellerCouponExternal();
      } else {
        // console.log(222);
      }
    },

    getSpecialGoods() {
      const obj = {
        current: this.belongPage.current,
        size: this.belongPage.size
      }
      this.tableLoading = true
      getSpecialGoods(obj).then((res) => {
        this.tableBelongData = res.data.records
        this.belongPage.total = res.data.total
        this.tableLoading = false
        console.log('专属下单res------>', res)
      })
    },

    searchForm(val) {
      this.formList.type = val.type;
      this.formList.display = val.display;
      this.formList.grantType = val.grantType;
      this.quireList();
    },
    searchFormTwo(val) {
      this.formListTwo.name = val.name;
      this.formListTwo.discount = val.discount;
      this.querySellerCouponExternal();
    },
    chooseTab(val) {
      let params = {
        singleAmount: 1,
        discount: val.amount,
        name: val.benefitName,
        couponId: val.id,
        quota: val.remainPrizeQuantity,
        couponType: 3,
      };
      // val.singleAmount = 1;
      this.$emit("choose-shop", params, 1);
    },
    storePoint() {
      this.generalCoupon = {
        batchKey: "",
        price: "",
        assetsId: null,
        couponType: 4,
        prizeType: 1,
        singleAmount: 1,
      };
      this.integralForm.singleAmount = this.integralForm.discount;
      this.$emit("choose-shop", this.integralForm, 4);
    },
    jingDonData() {
      if ((this.formLitZC.assetType = 5)) {
        //E卡
        this.zcData = {
          couponId: this.ekForm.region.value.id,
          discount: parseFloat(this.ekForm.region.value.quota),
          name: this.ekForm.region.label,
          singleAmount: 1,
        };
      } else if ((this.formLitZC.assetType = 6)) {
        //爱奇艺会员
        this.zcData = {
          couponId: this.aqyForm.region.value.id,
          discount: this.aqyForm.region.value.quota,
          name: this.aqyForm.region.label,
          singleAmount: 1,
        };
      } else if ((this.formLitZC.assetType = 7)) {
        //PLUS会员
        this.zcData = {
          couponId: this.plusForm.region.value.id,
          discount: this.plusForm.region.value.quota,
          name: this.plusForm.region.label,
          singleAmount: 1,
        };
      }
      // console.log(this.zcData, 222);
    },
    // 现金红包设置
    redData() {
      console.log(this.redForm.region.value, 2222222);
      this.zcData = {
        couponId: this.redForm.region.value.id,
        discount: this.redForm.num,
        name: this.redForm.region.label,
        singleAmount: 1,
      };
    },
    changeJP() {
      this.zcData = {
        giftType: this.objectForm.resource,
        logo: this.objectForm.logo,
        couponId: this.objectForm.wareId,
        discount: this.objectForm.discount,
        name: this.objectForm.name,
        singleAmount: 1,
      };
      this.generalCoupon = {
        batchKey: "",
        price: "",
        assetsId: null,
        couponType: 4,
        prizeType: 1,
        singleAmount: 1,
      };
      this.dialogVisibleFrom = false;
      this.$emit("choose-shop", this.zcData, 3);
    },
    jingDonEka() {
      this.$emit("choose-shop", this.zcData, 5);
    },
    aqyList() {
      this.$emit("choose-shop", this.zcData, 6);
    },
    plusList() {
      this.$emit("choose-shop", this.zcData, 7);
    },
    redList() {
      this.$emit("choose-shop", this.zcData, 8);
    },
    //上传图片
    handleChange(file, fileList) {
      const isLt3M = file.size < 1024 * 300;
      if (!isLt3M) {
        this.$message.error("上传图片大小不能超过 300K");
        this.$refs.upload.clearFiles();
      } else {
        this.fileList = fileList;
        this.$refs.upload.$children[1].$el.style.display = "none";
        // this.objectForm.name = file.name;
        let formdata = new FormData();
        formdata.append("file", file.raw);
        uploadpic(formdata).then((res) => {
          // 获取图片真实url
          this.objectForm.logo = res.data;
        });
      }
    },

    handleRemove(file, fileList) {
      // this.fileList = [];
      // this.$refs.upload.clearFiles();
      // this.imageName = "";
      this.$refs.upload.$children[1].$el.style.display = "inline-block";
    },
    httpRequest() {},
    //分页事件
    handleSizeChange(val) {
      this.formList.size = val;
      this.quireList();
    },
    handleCurrentChange(val) {
      this.formList.current = val;
      this.quireList();
    },
    handleSizeChangeTwo(val) {
      this.formListTwo.size = val;
      this.quireList();
    },
    handleCurrentChangeTwo(val) {
      this.formListTwo.current = val;
      this.quireList();
    },
    //分页事件
    handleSizeChangeThr(val) {
      this.formShopList.size = val;
      this.getShopList();
    },
    handleCurrentChangeThr(val) {
      this.formShopList.current = val;
      this.getShopList();
    },
    handleSizeChangeThe(val) {
      this.belongPage.size = val;
      this.getSpecialGoods();
    },
    handleCurrentChangeThe(val) {
      this.formShopList.current = val;
      this.getSpecialGoods();
    },
  },
};
</script>

<style scoped lang="scss">
.toLink {
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}
.shopClass {
  width: 115px;
  background: rgba(38, 112, 251, 0.1);
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #2670fb;
  color: #2670fb;
}
.search {
  color: #fff;
  border: 1px solid #2670fb;
  background-color: #2670fb;
  &:hover {
    opacity: 0.8;
  }
}
/deep/.el-tabs__header {
  margin-bottom: 24px;
}
/deep/.el-upload--picture-card {
  width: 80px;
  height: 80px;
  line-height: 87px;
}
.Notetake {
  cursor: pointer;
  color: #7f85e9;
  &:hover {
    color: #fe4d45;
  }
}
.btnCeate {
  width: auto;
  background: rgba(38, 112, 251, 0.1);
  border: 1px solid #2670fb;
  color: #2670fb;
}
.refresh {
  display: inline-block;
  color: #2670fb;
  width: 85px;
  position: relative;
  padding-left: 34px;
  &::before {
    content: "";
    position: absolute;
    display: block;
    width: 23px;
    height: 18px;
    top: 5px;
    left: 12px;
    background: url("../../assets/thdImg/pages/refresh.svg") no-repeat;
  }
}
.jingdouBox {
  width: 952px;
  // height: 186px;
  margin-top: 16px;
  background: #f4f7ff;
  border-radius: 4px;
  padding: 14px;
  color: #666;
  > p {
    font-size: 12px;
    margin-left: 17px;
    line-height: 24px;
  }
}
.uploadBox {
  /deep/.el-upload-list__item {
    width: 80px;
    height: 80px;
  }
  display: flex;
  &-desc {
    font-size: 12px;
    color: #999;
    padding: 8px 0 8px 15px;
    > p {
      line-height: 20px;
    }
  }
}
.authorization {
  width: 164px;
  height: 32px;
  background: rgba(38, 112, 251, 0.1);
  border-radius: 4px;
  line-height: 32px;
  text-align: center;
  border: 1px solid #2670fb;
  color: #2670fb;
  margin-top: 24px;
  margin-bottom: 100px;
}
.topTis {
  display: flex;
  align-items: baseline;
  color: #333;
  font-size: 14px;
  background: #fdf6ec;
  // margin: 30px;
  margin-bottom: 24px;
  padding: 12px;
  color: #333;
  margin-left: 0px;
  .desc {
    line-height: 20px;
  }
  p {
    margin-left: 5px;
    line-height: 20px;
  }
}
.screen-box {
  .line {
    font-size: 14px;
    color: #666666;
    margin-bottom: 10px;
    .item {
      display: inline-block;
      vertical-align: middle;
      // margin-right: 55px;
      .input {
        display: inline-block;
        vertical-align: middle;
        width: 200px;
      }
      .brandButton {
        width: 300px;
      }
      .classify-select {
        display: inline-block;
        vertical-align: middle;
        width: 145px;
        margin-right: 13px;
      }
      .goods-button {
        display: inline-block;
        vertical-align: middle;
        width: 141px;
      }
      .long-input {
        width: 270px;
      }
      .goods-select {
        width: 200px;
      }
      .short-input {
        width: 85px;
        display: inline-block;
        vertical-align: middle;
      }
      .text {
        display: inline-block;
        margin: 0 10px;
      }
    }
  }
}
.generalCoupon {
  margin-top: 20px;
  margin-left: 43px;
}
</style>
